import React from "react";


import { connect } from "react-redux";
import AccountLedgerSubComponent1 from "./AccountLedgerSubComponent1";
import AccountLedgerSubTxnModal from "./AccountLedgerSubTxnModal";


class AccountLedgerBillHistory extends React.Component{
    constructor(props){
        super(props);
        this.state={
			phoneNo: this.props.phone
		}
    }


    componentDidMount(){

	}
	componentWillUnmount(){
    }

  
    render(){
    console.log('Inside render');
    return(
        
					<div>
						<div class="billhistory" id="txnlist">
							
							<div class="txn-item">
								<div class="txn-head" id="txnhead1">
									<div class="collapsed" data-bs-toggle="collapse" 
									data-bs-target="#txn1" aria-expanded="false" aria-controls="txn1">					
										<AccountLedgerSubComponent1/>
									</div>
								</div>
						
								<div id="txn1" class="accordion-collapse collapse" 
								aria-labelledby="txnhead1" data-bs-parent="#txnlist">
									<AccountLedgerSubTxnModal/>
								</div>
							</div>
							
							<div class="txn-item">
								<div class="txn-head" id="txnhead2">
									<div class="collapsed" data-bs-toggle="collapse" 
									data-bs-target="#txn2" aria-expanded="false" aria-controls="txn2">					
									<AccountLedgerSubComponent1/>	
									</div>
								</div>
						
								<div id="txn2" class="accordion-collapse collapse"
								 aria-labelledby="txnhead2" data-bs-parent="#txnlist">
								<AccountLedgerSubTxnModal/>
								</div>
							</div>
							
							<div class="txn-item">
								<div class="txn-head" id="txnhead3">
									<div class="collapsed" data-bs-toggle="collapse" data-bs-target="#txn3" aria-expanded="false" aria-controls="txn3">					
									<AccountLedgerSubComponent1/>
									</div>
								</div>
						
								<div id="txn3" class="accordion-collapse collapse" 
								aria-labelledby="txnhead3" data-bs-parent="#txnlist">
									<AccountLedgerSubTxnModal/>
								</div>
							</div>
							
							<div class="txn-item">
								<div class="txn-head" id="txnhead4">
									<div class="collapsed" data-bs-toggle="collapse" data-bs-target="#txn4" aria-expanded="false" aria-controls="txn4">					
										<AccountLedgerSubComponent1/>
									</div>
								</div>
								<div id="txn4" class="accordion-collapse collapse" aria-labelledby="txnhead4" data-bs-parent="#txnlist">
								<AccountLedgerSubTxnModal/>
								</div>
							</div>
							
							<div class="txn-item">
								<div class="txn-head" id="txnhead5">
									<div class="collapsed" data-bs-toggle="collapse" data-bs-target="#txn5" aria-expanded="false" aria-controls="txn5">					
									<AccountLedgerSubComponent1/>
									</div>
								</div>
						
								<div id="txn5" class="accordion-collapse collapse" aria-labelledby="txnhead5" data-bs-parent="#txnlist">
								<AccountLedgerSubTxnModal/>
								</div>
							</div>
							
							<div class="txn-item">
								<div class="txn-head" id="txnhead6">
									<div class="collapsed" data-bs-toggle="collapse" data-bs-target="#txn6" aria-expanded="false" aria-controls="txn6">					
									<AccountLedgerSubComponent1/>
									</div>
								</div>
						
								<div id="txn6" class="accordion-collapse collapse" aria-labelledby="txnhead6" data-bs-parent="#txnlist">
								<AccountLedgerSubTxnModal/>
								</div>
							</div>
							
							<div class="txn-item">
								<div class="txn-head" id="txnhead7">
									<div class="collapsed" data-bs-toggle="collapse" data-bs-target="#txn7" aria-expanded="false" aria-controls="txn7">					
									<AccountLedgerSubComponent1/>
									</div>
								</div>
						
								<div id="txn7" class="accordion-collapse collapse" aria-labelledby="txnhead7" data-bs-parent="#txnlist">
								<AccountLedgerSubTxnModal/>
								</div>
							</div>
							
							<div class="txn-item">
								<div class="txn-head" id="txnhead8">
									<div class="collapsed" data-bs-toggle="collapse" data-bs-target="#txn8" aria-expanded="false" aria-controls="txn8">					
									<AccountLedgerSubComponent1/>
									</div>
								</div>
						
								<div id="txn8" class="accordion-collapse collapse" aria-labelledby="txnhead8" data-bs-parent="#txnlist">
								<AccountLedgerSubTxnModal/>
								</div>
							</div>
							
								<div class="txn-item">
								<div class="txn-head" id="txnhead9">
									<div class="collapsed" data-bs-toggle="collapse" data-bs-target="#txn9" aria-expanded="false" aria-controls="txn9">					
									<AccountLedgerSubComponent1/>
									</div>
								</div>
						
								<div id="txn9" class="accordion-collapse collapse" aria-labelledby="txnhead9" data-bs-parent="#txnlist">
								<AccountLedgerSubTxnModal/>
								</div>
							</div>
							
                            
						</div>
						
						<div class="pager">
							<p>Showing 1 to 10 of 270 entries</p>					
							<ul class="pagination pagination-sm">
								<li class="page-item"><a class="page-link" href="#">Prev</a></li>
								<li class="page-item active"><a class="page-link" href="#">1</a></li>
								<li class="page-item"><a class="page-link" href="#">2</a></li>
								<li class="page-item"><a class="page-link" href="#">3</a></li>
								<li class="page-item"><a class="page-link" href="#">4</a></li>
								<li class="page-item"><a class="page-link" href="#">Next</a></li>
							</ul>						
                        </div>						
                        </div>
		);
      } 
}

const mapStateToProps = (
	{ errorMessageReduce:{errorMessage,loginErrorMessage,otpErrorMessage},
	 miscReduce:{otpRefNo,phone}}
	) => ({
		errorMessage,loginErrorMessage,otpErrorMessage,otpRefNo,phone
});

export default connect(mapStateToProps, null)(AccountLedgerBillHistory);
